// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"bde89308","61":"90e589bf","153":"4bde3463","857":"81f305a4","859":"21b9f417","958":"5a04c7ef"}[chunkId] + ".chunk.js";
};